/**
 * Plugin icon
 */

const pluginIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={{ isolation: "isolate" }}
    viewBox="0 0 20 20"
    width="20"
    height="20"
  >
    <defs>
      <clipPath id="_clipPath_oiZWIIJHUvztXEYqFdz1mTnkAkEbbbUu">
        <rect width="20" height="20" />
      </clipPath>
    </defs>
    <g clipPath="url(#_clipPath_oiZWIIJHUvztXEYqFdz1mTnkAkEbbbUu)">
      <g id="Group" fill="#555D66">
        <path d="M 10 20 C 9.559 20 9.126 19.936 8.703 19.817 C 4.647 18.673 1.535 12.413 1.535 8.206 C 1.535 3.587 5.252 0 10 0 C 14.748 0 18.465 3.613 18.465 8.206 C 18.465 12.852 14.671 20 10 20 Z M 10 1.032 C 5.819 1.032 2.568 4.181 2.568 8.206 C 2.568 12.361 5.974 18.942 10 18.942 C 14.026 18.942 17.432 12.361 17.432 8.206 C 17.432 4.181 14.181 1.032 10 1.032 Z" />
        <path d="M 3.806 9.497 C 3.497 9.497 3.239 9.213 3.29 8.903 C 3.342 8.645 3.574 8.465 3.832 8.465 C 7.342 8.465 8.039 7.51 8.039 7.51 C 8.039 7.535 8.013 7.535 8.013 7.535 L 8.013 7.535 C 8.529 7.819 8.503 8.542 7.987 8.8 C 7.265 9.161 6 9.497 3.806 9.497 Z" />
        <path d="M 15.755 7.432 C 15.755 7.432 15.058 6.477 11.548 6.477 C 11.29 6.477 11.032 6.297 11.006 6.039 C 10.955 5.729 11.213 5.445 11.523 5.445 C 13.716 5.445 14.981 5.781 15.729 6.142 C 16.219 6.426 16.245 7.148 15.755 7.432 L 15.755 7.432 C 15.729 7.406 15.729 7.432 15.755 7.432 Z" />
        <path d="M 6.077 9.729 C 6.077 9.259 6.459 8.877 6.929 8.877 C 7.399 8.877 7.781 9.259 7.781 9.729 C 7.781 10.199 7.399 10.581 6.929 10.581 C 6.459 10.581 6.077 10.199 6.077 9.729 Z" />
        <path d="M 12.219 9.729 C 12.219 9.259 12.601 8.877 13.071 8.877 C 13.541 8.877 13.923 9.259 13.923 9.729 C 13.923 10.199 13.541 10.581 13.071 10.581 C 12.601 10.581 12.219 10.199 12.219 9.729 Z" />
        <path d="M 9.2 16 C 8.503 16 7.961 15.974 7.729 15.948 C 7.445 15.923 7.239 15.665 7.265 15.381 C 7.29 15.097 7.523 14.89 7.832 14.916 C 9.355 15.045 11.755 14.968 12.348 14.4 C 12.426 14.323 12.426 14.271 12.426 14.245 C 12.426 13.961 12.658 13.729 12.942 13.729 C 13.226 13.729 13.458 13.961 13.458 14.245 C 13.458 14.581 13.303 14.916 13.045 15.174 C 12.271 15.845 10.49 16 9.2 16 Z" />
      </g>
    </g>
  </svg>
);

export default pluginIcon;



// WEBPACK FOOTER //
// ./src/data/icon.js